import { Button, Empty } from "antd";

interface Props {
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

/**
 * Onboarding-friendly empty state for list pages — instead of a bare "No data",
 * tell the customer what to do next and offer the action (AWS-console style).
 */
function EmptyState({ description, actionLabel, onAction }: Props) {
  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={description}
      style={{ padding: "32px 0" }}
    >
      {actionLabel && onAction ? (
        <Button type="primary" onClick={onAction}>
          {actionLabel}
        </Button>
      ) : null}
    </Empty>
  );
}

export default EmptyState;
